// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_BuscaOrcamentoServicosPorOrcamentoIDResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /orcamentos_servicos/buscaOrcamentoServicosPorOrcamentoID
 *
 * Returns a list of orcamento_servico records for a given orcamento_id,
 * with a computed servico_label from the JOIN.
 */
import type { OrcamentosServicos_BuscaOrcamentoServicosPorOrcamentoIDRow } from './OrcamentosServicos_BuscaOrcamentoServicosPorOrcamentoIDRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OrcamentosServicos_BuscaOrcamentoServicosPorOrcamentoIDResponseDados = OrcamentosServicos_BuscaOrcamentoServicosPorOrcamentoIDRow[];

export type OrcamentosServicos_BuscaOrcamentoServicosPorOrcamentoIDResponse = ApiResponse<OrcamentosServicos_BuscaOrcamentoServicosPorOrcamentoIDResponseDados>;

registerResponseContract('OrcamentosServicos_BuscaOrcamentoServicosPorOrcamentoIDResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      orcamento_servico_id:      { type: 'number',  required: true },
      orcamento_id:              { type: 'number',  required: true },
      servico_id:                { type: 'number',  required: true },
      servico_valor:             { type: 'number',  required: true },
      orcamento_servico_qtd:     { type: 'number',  required: true },
      orcamento_servico_status:  { type: 'number',  required: true },
      orcamento_servico_tipo:    { type: 'number',  required: true },
      orcamento_servico_user_id: { type: 'string',  required: false },
      servico_label:             { type: 'string',  required: true },
    },
  },
})
